<template>
  <v-container>
    <v-app-bar app color="white">
      <v-row>
        <v-col cols="auto" class="mx-auto">
          <v-btn
            outlined
            color="primary"
            to="/features/reviews/settings/questions"
            class="mr-2"
          >
            Exit Preview
          </v-btn>
          Your answers will not be saved. Close this tab to get back to your
          builder.
        </v-col>
      </v-row>
    </v-app-bar>
    <v-row>
      <v-col cols="12">
        <v-card color="accent">
          <v-row>
            <v-col cols="auto" class="my-auto ml-8">
              <v-icon size="75" color="secondary">live_help</v-icon>
            </v-col>
            <v-col>
              <v-card-title class="pb-0">
                360 Review Sample Preview
              </v-card-title>
              <v-card-text class="pt-0 secondary--text">
                These questions below will appear in your employee's task hub
                area and they'll be notified every Monday. By default all of our
                questions are collected on an opinion scale (0-10). We give
                members the ability to select NA if they are unable to answer
                the question. Additionally, there is a feedback comment on each
                question to collect any additional details the member would like
                to communicate.
              </v-card-text>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-card>
          <v-row>
            <v-col cols="12" md="4" class="mr-n1">
              <v-row>
                <v-col cols="auto">
                  <v-card-text class="py-0">
                    <user-avatar
                      :size="80"
                      :user="profile"
                      color="performance"
                      borderColor="performance"
                      cssClass="text-h3"
                      textColor="white"
                    ></user-avatar>
                  </v-card-text>
                </v-col>
                <v-col>
                  <v-card-title>{{ profile.fullName }}</v-card-title>
                  <v-card-subtitle>{{ profile.jobTitle }}</v-card-subtitle>
                </v-col>
              </v-row>
            </v-col>
            <v-divider vertical v-if="$vuetify.breakpoint.mdAndUp"></v-divider>
            <v-col
              cols="12"
              md="8"
              :class="$vuetify.breakpoint.mdAndUp ? 'mr-n1 pl-0 pr-2' : ''"
            >
              <v-divider v-if="!$vuetify.breakpoint.mdAndUp"></v-divider>
              <div v-for="(review, i) in reviews" :key="i">
                <v-row>
                  <v-col cols="12" class="pl-8 pr-8">
                    <div
                      class="subtitle-1 font-weight-bold secondarytext--text pb-4"
                    >
                      {{ review.question }}
                    </div>
                    <div class="d-flex flex-wrap">
                      <rating
                        class="mr-2"
                        v-model="review.answer"
                        v-on:change="saveAnswer(review, $event)"
                      ></rating>
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            height="40"
                            :dark="not_applicable(review)"
                            :outlined="!not_applicable(review)"
                            elevation="0"
                            class="mr-2"
                            @click="saveAnswer(review, null)"
                            :color="
                              not_applicable(review) ? 'secondary' : 'lighttext'
                            "
                            v-bind="attrs"
                            v-on="on"
                          >
                            NA
                          </v-btn>
                        </template>
                        <span class="pa-2">Not Applicable</span>
                      </v-tooltip>
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            :outlined="!review.feedback"
                            height="40"
                            :color="review.feedback ? 'secondary' : 'lighttext'"
                            v-bind="attrs"
                            v-on="on"
                          >
                            <v-icon>message</v-icon>
                          </v-btn>
                        </template>
                        <span class="pa-2">Leave Feedback</span>
                      </v-tooltip>
                    </div>
                  </v-col>
                </v-row>
                <v-divider v-if="i < reviews.length - 1"></v-divider>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import Rating from "@/components/common/Rating";
export default {
  name: "ReviewPreview",
  components: { Rating },
  data: () => ({
    loading: false
  }),
  computed: {
    reviews() {
      return this._.take(
        this.active_questions.filter(
          x =>
            x.isEnabled &&
            this.$enums.questionTypes.OPINION_SCALE == x.questionTypeId
        ),
        3
      );
    },
    not_applicable() {
      return review => {
        return review.answer == null && !!review.completeDate;
      };
    },
    ...mapGetters({
      tab: "review/tab",
      profile: "profile/profile",
      is_admin: "profile/is_admin",
      active_questions: "settings/active_review_questions"
    })
  },
  created() {
    if (this.active_questions.length == 0) {
      this.loadData();
    }
  },
  methods: {
    loadData() {
      this.loading = true;
      Promise.all([this.$store.dispatch("settings/getReviewCategories")])
        .catch(error => {
          this.logError(error);
          this.$root.$alert(
            "Error Occurred",
            "An error occured while loading your review settings."
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
    saveAnswer(review, answer) {
      review.answer = answer;
      review.completeDate = moment();
    }
  }
};
</script>
